﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";
export class GuiDetailAdbKostenverteilung extends GuiDetailGeneric {
    constructor() {
        super("GuiDetailAdbKostenverteilung");
    }
}
